module.exports = __webpack_public_path__ + "static/media/bag.dbf58834.svg";